export default __webpack_public_path__ + "static/monitor_w.03bb9c50d0b49ab7aa7dfb9cc652828d.svg";